import * as z from 'zod/mini'
import { CreatePaymentForUsersBody, createPaymentForUsersBody } from '@seiri/shared/common'
import { assertFormNumber, requiredFormNumber, requiredText } from './form-schema'

/**
 * The create-payment dialog on the payments screen, which has no API behind it as of 2026-10-14 (docs/validation.md,
 * dead screens). The form requires a name and at least one client where the body leaves them optional, and the amount
 * is a number input that an empty field leaves `null` - hence its own schema and `toCreatePaymentBody`.
 */
export const createPaymentFormModel = z.object({
  name: z.string().check(requiredText),
  customerIds: createPaymentForUsersBody.shape.customerIds.check(z.minLength(1)),
  amount: requiredFormNumber(createPaymentForUsersBody.shape.amount),
  description: z.string(),
})
export type CreatePaymentFormModel = z.infer<typeof createPaymentFormModel>

export const emptyCreatePaymentFormModel = (): CreatePaymentFormModel => ({
  name: '',
  customerIds: [],
  amount: null,
  description: '',
})

export const toCreatePaymentBody = (model: CreatePaymentFormModel): CreatePaymentForUsersBody => ({
  name: model.name.trim(),
  customerIds: model.customerIds,
  amount: assertFormNumber(model.amount, 'amount'),
  description: model.description,
})
